module.exports = __webpack_public_path__ + "img/delete.2976cc6d.svg";